<div>
  <button (click)="updateAmortization()" mat-raised-button>Amorteringskrav</button>
  <button (click)="getLoans()" mat-raised-button>Hämta Lån</button>
  <button (click)="getApplications()" mat-raised-button>Hämta Ansökningar</button>
  <button (click)="dumpCredentials()" mat-raised-button>Credentials</button>
  <button (click)="onboard()" mat-raised-button>Onboard</button>
  <button (click)="offer()" mat-raised-button>Offra</button>
</div>
